import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import webTokenStorer from '../../utils/webStorer';
import { SOCIETY_PORTAL, SOCIETY_PORTAL_LOGIN } from '../routes';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = () => {
    const { loading, reloginLoading } = useSelector(state => state.loginReducer);
    const isLoggedIn = !!(webTokenStorer.getToken());

    return isLoggedIn ?
        <>
            {(loading || reloginLoading) ?
                <div className='tw-w-full tw-h-screen tw-flex tw-items-center tw-justify-center'>
                    <CircularProgress size="3rem" />
                </div>
                :
                <Outlet />
            }
        </>
        :
        <Navigate to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN} />
}

export default ProtectedRoute;
